import { markDeliveryCollectedInMock } from './deliveryDetail';

// Mock of the confirm-collect WRITE: simulate latency, then flip the delivery to Collected in the
// shared detail mock, so a follow-up fetchDeliveryDetailMock returns the Collected state and the
// «Recogido» row — the success flow is exercisable end to end in dev / MSW. Idempotent, like the
// real endpoint is asked to be.
export async function confirmDeliveryCollectMock(id: string): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, 100));
  markDeliveryCollectedInMock(id);
}
